import { useQuery } from '@tanstack/react-query';
import Cookies from 'js-cookie';

import { AUTH_COOKIE_NAME } from '@constants';
import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';
import { useTokenManager } from './useTokenManager';

export const refreshToken = (() => {
  let pendingPromise: Promise<string> | null = null;

  // eslint-disable-next-line max-statements
  return async () => {
    if (pendingPromise) {
      return pendingPromise;
    }

    try {
      const existingToken = Cookies.get(AUTH_COOKIE_NAME);

      if (!existingToken) {
        return null;
      }

      pendingPromise = apiClient.user.refreshToken.mutation({ body: { existingToken } }).then((result) => {
        if (result.status !== 200) throw result.body;
        const { refreshedToken } = result.body;
        Cookies.set(AUTH_COOKIE_NAME, refreshedToken);
        return refreshedToken;
      });

      const refreshedToken = await pendingPromise;
      pendingPromise = null;
      return refreshedToken;
    } catch (error) {
      pendingPromise = null;
      showErrorToast(error, 'Could not refresh token. Please log in again.');
      Cookies.remove(AUTH_COOKIE_NAME);
    }
  };
})();

export const useRefreshToken = () => {
  const { scheduleTokenRefresh } = useTokenManager();

  return useQuery({
    queryKey: ['refresh-token'],
    queryFn: async () => {
      const token = await refreshToken();
      scheduleTokenRefresh();
      return token;
    },
  });
};
